var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.36735 2.66254L8.08442 0.955329L6.28479 1.22512L5 0L3.71058 1.24281L1.91558 0.959752L1.63265 2.65369L0.00463822 3.45422L0.825603 4.98894L0 6.53693L1.61874 7.32419L1.90631 9.04467L3.69666 8.76161L4.98609 10L6.27087 8.7793L8.07514 9.04909L8.35807 7.34188L10 6.5502L9.1744 5.00221L9.99536 3.45422L8.36735 2.66254ZM3.14471 3.45422C3.14471 3.08783 3.4562 2.7908 3.84045 2.7908C4.22469 2.7908 4.53618 3.08783 4.53618 3.45422C4.53618 3.82062 4.22469 4.11765 3.84045 4.11765C3.4562 4.11765 3.14471 3.82062 3.14471 3.45422ZM6.15955 5.88678C5.77531 5.88678 5.46382 6.1838 5.46382 6.5502C5.46382 6.9166 5.77531 7.21362 6.15955 7.21362C6.5438 7.21362 6.85529 6.9166 6.85529 6.5502C6.85529 6.1838 6.5438 5.88678 6.15955 5.88678ZM7.31911 3.41442L3.33488 7.21362L2.68089 6.59L6.66512 2.7908L7.31911 3.41442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.42a2033ae79b7303a1fc7245406219f7.svg";
export { ForwardRef as ReactComponent };